import React, { useContext } from 'react';
import { NavItem } from '@internal/schema-client';
import * as iconsModule from '@gjensidige/builders-icons';
import { Nav } from '@gjensidige/core-navigation';

// Enable refering to icons by lowercase names
const icons = Object.keys(iconsModule).reduce((all, name: string) => {
  all[name.toLowerCase()] = iconsModule[name];
  return all;
}, {});

type Props = {
  currentPath?: string;
  homeUrl?: string;
  items: Array<NavItem>;
  notifications?: object;
};

export const ApiToNavItems = ({
  currentPath = '',
  homeUrl,
  items,
  notifications = {}
}: Props): JSX.Element => {
  const isHome = currentPath === homeUrl;
  const isMobile = useContext(Nav.isMobile);
  const texts = useContext(Nav.language);

  return (
    <>
      {items?.map((item, index: number) => {
        const isParent = item.children?.length;
        const Icon = icons[item.icon];
        const Item = homeUrl ? Nav.CMS : Nav.Item;
        const rest = {};

        if (isMobile && !isHome) rest['open'] = item.isExpanded; // Auto expand mobile
        if (!isMobile || !isParent) rest['href'] = item.href; // Prevent href if mobile toggle for children
        if (!isMobile && homeUrl) rest['open'] = item.isExpanded; // Auto expand desktop

        return (
          <Item
            aria-current={item.href === currentPath}
            aria-disabled={item.private || undefined}
            badge={notifications[item.notificationsKey]}
            icon={Icon && <Icon />}
            key={`${item.label}${index}${isMobile}`}
            label={item.label}
            {...rest}
          >
            {isParent ? (
              <>
                {!item.href || !isMobile || (
                  <Nav.Item
                    href={item.href}
                    label={`${texts.gotofront} ${item.label}`}
                  />
                )}
                <ApiToNavItems
                  currentPath={currentPath}
                  items={item.children}
                  notifications={notifications}
                />
                {item.ctas?.map(({ label, href }, index: number) => (
                  <Nav.CTA key={`${label}${index}`} href={href} label={label} />
                ))}
              </>
            ) : null}
          </Item>
        );
      })}
    </>
  );
};
